<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,12C15,12,2,12,2,12C2,12,2,9.41,2,9.41C2,9.41,5,6.41,5,6.41C5,6.41,8.29,9.7,8.29,9.7C8.47,9.89,8.72,10,9,10C9.28,10,9.53,9.89,9.71,9.71C9.71,9.71,15.71,3.71,15.71,3.71C15.89,3.5300000000000002,16,3.2800000000000002,16,3C16,2.45,15.55,2,15,2C14.72,2,14.47,2.11,14.29,2.29C14.29,2.29,9,7.59,9,7.59C9,7.59,5.71,4.29,5.71,4.29C5.53,4.109999999999999,5.28,4,5,4C4.72,4,4.47,4.109999999999999,4.29,4.29C4.29,4.29,2,6.59,2,6.59C2,6.59,2,3,2,3C2,2.45,1.55,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,15,12,15,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'TimelineLineChart',
} as DefineComponent
</script>
